export const LEGAL_INFORMATION = {
	brandName: "LookDat",
	publisherName: "Monsieur Dorian Ankry",
	publicationDirector: "Dorian Ankry",
	legalForm: "Entrepreneur individuel",
	siren: "948 390 653",
	address: "150 avenue de Versailles 2 rue Jouvenet, 75016 Paris, France",
	legalEmail: "legal@lookdat.com",
	contactEmail: "legal@lookdat.com",
	hostName: "Cloudflare, Inc.",
	hostAddress: "101 Townsend Street, San Francisco, CA 94107, United States",
} as const;
